import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={24.861}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 36467 35275"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541132656">
        <path
          d="M25305 15932c744 0 1554-102 2437-342 4518-1235 5623-4733 5857-5802l-13853 3782c603 646 2488 2362 5559 2362z"
          className="fil0"
        />
        <path
          d="M36041 6951c-44-56-4303-5373-11981-3418L18671 422c-830-479-1816-553-2710-204L9955 2567c-1209 473-1992 1619-1992 2918v5274h-850v2191h-273L5684 31060H1679c-926 0-1679 752-1679 1679v857c0 924 753 1679 1679 1679h13492c926 0 1679-755 1679-1679v-857c0-927-753-1679-1679-1679h-4005l-1156-18111-273 1v-2191h-848V5485c0-915 552-1723 1404-2057l6006-2348c627-243 1322-192 1908 146l4632 2671c-6956 2420-7863 8743-7873 8807l-88 691 3868-1056 13853-3783 3868-1056-426-549z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
